export function getWindow() {
  // @ts-expect-error returning window object
  return window;
}